module.exports = __webpack_public_path__ + "static/media/248.0c92616f.svg";